import { styled, Grid, Typography } from '@material-ui/core'
import { ReactComponent as LogoColor } from 'shared/icons/named_logo_color.svg'

const IMAGE_HEIGHT = 250
const LOGO_HEIGHT = 40

export const Container = styled(Grid)(({ theme }) => ({
  height: '100%',
  maxWidth: '100vw',
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(0, 1.5),
}))

export const Logo = styled(LogoColor)(({ theme }) => ({
  height: LOGO_HEIGHT,
  marginTop: theme.spacing(4),
}))

export const Subtitle = styled(Typography)(({ theme }) => ({
  fontSize: 20,
  lineHeight: '36px',
  fontWeight: 500,
  color: theme.palette.common.black,
  textAlign: 'center',
  marginTop: theme.spacing(6),
}))

export const Image = styled('img')(({ theme }) => ({
  height: IMAGE_HEIGHT,
  width: 'auto',
  marginTop: theme.spacing(4),
}))

export const Link = styled('a')(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'none',
  fontWeight: 700,
}))
